import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Bounce, toast } from 'react-toastify';
import {
  Calendar,
  moneyWhite,
  star,
  chatRound,
  timesOffer,
  checkOffer,
} from '../../assets/icons';
import {
  defaultLettersCircle,
  languageAr,
  toastConfig,
} from '../../helpers/helper';
import i18n from '../../languages/i18n';
import { updateStatusOffer } from '../../services/apis/owner';
import ButtonIcon from '../buttons/ButtonIcon';
import { Button, CheckBox, MConfirmation, Textarea } from './../index';
import { getUserInfo } from './../../services/apis/user';
import { initiateChatCarOwner } from './../../services/apis/chat';

const CardOffer = ({ onClick, offer, goOffer, refreshOffer }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loadingUpdateAccept, setLoadingUpdateAccept] = useState(false);
  const [loadingUpdateReject, setLoadingUpdateReject] = useState(false);
  const [rejectOfferModal, setRejectOfferModal] = useState(false);
  const [rejectMessage, setRejectMessage] = useState('');
  const [selectedCause, setSelectedCause] = useState([]);
  const [causes, setCauses] = useState([
    t('offerDetails.offerNotResponsable'),
    t('offerDetails.overCommission'),
    t('offerDetails.overPrice'),
  ]);
  const [userInfo, setUserInfo] = useState(null);
    const { id } = useParams();
  

  const handleUserInfo = async () => {
    const response = await getUserInfo();
    setUserInfo(response);
  };

  useEffect(() => {
    handleUserInfo();
  }, []);

  const loader = (type) => {
    let loaderFalse =
      type == 'accept'
        ? setLoadingUpdateAccept(false)
        : setLoadingUpdateReject(false);
    return loaderFalse;
  };

  const offerUpdateStatus = async (type) => {
    type == 'accept'
      ? setLoadingUpdateAccept(true)
      : setLoadingUpdateReject(true);

    if (type === 'reject') {
      if (!rejectMessage) {
        toast.error(
          t('offerDetails.rejectCauseRequired'),
          toastConfig,
          loader(type)
        );
        setLoadingUpdateReject(false);
        return;
      }
    }

    let data = {
      offerStatusId: type == 'accept' ? 3 : 2,
      statusMessage: rejectMessage + '    ' + selectedCause.join(','),
    };
    try {
      const response = await updateStatusOffer(data, offer.id);
      refreshOffer();
      window.location.reload(false);
      toast.success(
        t('offerDetails.updateStatusSuccess'),
        toastConfig,
        loader(type)
      );
    } catch (error) {
      if (error.response) {
        if (error.response.status == 400) {
          toast.error(error.response.data.message, toastConfig, loader(type));
        } else if (error.response.status == 500) {
          toast.error(error.response.data.message, toastConfig, loader(type));
        }
      }
    }
  };

  const handleChangeCause = (cause, isChecked) => {
    const updatedSelectedCause = isChecked
      ? [...selectedCause, cause] 
      : selectedCause.filter((item) => item !== cause); 

    setSelectedCause(updatedSelectedCause);

    setRejectMessage(updatedSelectedCause.join("\n"));
  };


    const handleRejectMessageChange = (e) => {
    const message = e.target.value;
    setRejectMessage(message);

    const updatedSelectedCause = message
      .split("\n")
      .map((line) => line.trim()) 
      .filter((line) => causes.includes(line)); 

    setSelectedCause(updatedSelectedCause);
  };

  return (
    <div className="rounded-[20px] bg-[#ACEBEB] cursor-pointer flex flex-col justify-between shadow-lg h-[100%]">
      <div>
        <div className="flex flex-row justify-between items-center">
          <div
            className={`bg-[#00CEBC] flex flex-row items-center ${
              languageAr
                ? 'rounded-tl-[0px] rounded-tr-[20px] rounded-bl-[20px] rounded-br-[0px]'
                : 'rounded-tl-[20px] rounded-tr-[0px] rounded-bl-[0px] rounded-br-[20px]'
            } text-[14px] text-[#ffffff] p-4 h-[50px]`}
          >
            <div>{t('listOrdersCarOwner.offerNumber')}</div>
            <div className="px-2">:</div>
            <div>#{offer.id} </div>
          </div>
          <div className="flex flex-row items-center p-2 bg-[#E6EDFF] rounded-[7px] mx-5">
            <div>
              <img src={Calendar} className="w-[20px] h-[20px]" />
            </div>
            <div className="text-[13px] font-[600px] text-[#000000] px-2">
              12-01-2024
            </div>
            <div className="text-[11px] font-[600px] text-[#6A6A6A]">
              12:13:20
            </div>
          </div>
        </div>
        <div className="flex flex-row items-center w-[90%] mr-auto ml-auto mt-5">
          <div
            className="rounded-full p-1 bg-[#73D3CB]"
            onClick={() =>
              navigate(`/profile-info/${offer?.medInfo?.id}`, { state: offer })
            }
          >
            {offer.medInfo.profileImg == null ? (
              defaultLettersCircle(offer.medInfo.fullName)
            ) : (
              <img
                className="w-[36px] h-[36px] rounded-full"
                src={offer.medInfo.profileImg}
              />
            )}
          </div>
          <div className="flex flex-col mx-3">
            <div
              className="flex flex-row items-center text-[#3E0292] text-[15px] font-700"
              onClick={() =>
                navigate(`/profile-info/${offer?.medInfo?.id}`, {
                  state: offer,
                })
              }
            >
              <div>{t('listOffers.mediator')}</div>
              <div className="px-2">:</div>
              <div>{offer.medInfo.fullName}</div>
            </div>
            <div className="flex flex-row items-center">
              <div
                onClick={() =>
                  navigate(`/profile-info/${offer?.medInfo?.id}`, {
                    state: offer,
                  })
                }
              >
                <img src={star} />
              </div>
              <div
                className="text-[#3E0292] text-[15px] font-700 mx-3"
                onClick={() =>
                  navigate(`/profile-info/${offer?.medInfo?.id}`, {
                    state: offer,
                  })
                }
              >
                {offer.medInfo.medAvgRating}
              </div>
              {offer.statusId == 3 ? (
                <div
                  className="bg-[#00CEBC] rounded-[12px] shadow-lg flex flex-row justify-center items-center p-1"
                  onClick={async () => {
                    let conversationId = offer.conversationId;

                    // If no conversation exists, create one
                    if (!conversationId) {
                      let body;
                      if (userInfo?.userRole?.roleId === 2) {
                        body = {
                          smOfferId: offer.id,
                          receiverId: offer.medInfo?.id,
                          senderId: userInfo.userId,
                        };
                      } else if (userInfo?.userRole?.roleId === 3) {
                        body = {
                          smOfferId: offer.id,
                          receiverId: order.sellMediationId,
                          senderId: offer.medInfo?.id,
                        };
                      }

                      try {
                        const response = await initiateChatCarOwner(body);

                        if (!response?.conversationId) {
                          throw new Error('No conversation ID returned');
                        }

                        conversationId = response.conversationId;
                      } catch (error) {
                        console.error(
                          'Chat creation error:',
                          error?.response?.data || error
                        );
                        return;
                      }
                    }

                    if (!conversationId) {
                      console.error('No valid conversation ID available');
                      toast.error(t('chat.conversationError'), toastConfig);
                      return;
                    }

                    const chatData = {
                      selectedOffer: {
                        medOfferId: offer.id,
                        smId: parseInt(id),
                        conversationId: conversationId,
                        receiverInfo: {
                          id: offer.medInfo?.id,
                          fullName: offer.medInfo?.fullName,
                          profileImg: offer.medInfo?.profileImg,
                        },
                        lastMessage: null,
                        unreadCount: 0,
                        lastMessageTime: new Date().toISOString(),
                      },
                      autoSelectChat: true,
                      fromOfferDetails: true,
                      isCarOwnerChat: true,
                      defaultActiveTab: 1, // This will select the owner chats tab
                      chatType: 'owner', // Additional identifier for owner chat type
                    };

                    navigate('/chats', {
                      state: chatData,
                    });
                  }}
                >
                  <img src={chatRound} />
                  <div className="text-[13px] font-400 text-white mx-3">
                    {t('statusActions.conversation')}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div onClick={onClick}>
          <div className="flex flex-row items-center mx-3 my-3">
            <div className="text-[#3E0292] text-[14px] font-500">
              {t('offerDetails.commission')}:
            </div>
            <div className="flex flex-row bg-[#04C500CC] rounded-[12px] p-2 mx-2">
              <div>
                <img src={moneyWhite} className="w-[20px] h-[20px]" />
              </div>
              <div className="flex flex-row items-center px-2">
                <div className="text-[12px] font-500 text-[#ffffff] px-2">
                  {offer.commission}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-3 my-3">
          <Textarea
            disabled={true}
            label={t('statusActions.comment')}
            value={offer.comment}
            placeholder={
              offer.comment == ''
                ? t('statusActions.notFoundComment')
                : offer.comment
            }
            rows={4}
          />
        </div>
      </div>

      {offer.statusId == 2 ? (
        <div className="grid md:grid-cols-1 lg:grid-cols-1 2xl:grid-cols-1 xl:grid-cols-1 sm:grid-cols-1 w-[50%] mr-auto ml-auto gap-x-2 mt-5 mb-[-30px]">
          <ButtonIcon
            className="bg-[#DDC0D9] border border-[#DDC0D9] max600:mb-3 sm:mb-3 xl:mb-0 lg:mb-0 2xl:mb-0 md:mb-0 shadow-lg"
            titleClass={'text-[#FD2828] text-[14px] font-500'}
            icon={timesOffer}
            dark={false}
            title={t('statusActions.rejectRequest')}
          />
        </div>
      ) : offer.statusId == 3 ? (
        <div className="grid md:grid-cols-1 lg:grid-cols-1 2xl:grid-cols-1 xl:grid-cols-1 sm:grid-cols-1 w-[50%] mr-auto ml-auto gap-x-2 mt-5 mb-[-30px]">
          <ButtonIcon
            className="bg-[#DEF3FF] border border-[#DEF3FF] max600:mb-3 sm:mb-3 xl:mb-0 lg:mb-0 2xl:mb-0 md:mb-0 shadow-lg text-[#00CEBC]"
            titleClass={'text-[#00CEBC] text-[14px] font-500'}
            icon={checkOffer}
            dark={false}
            title={t('statusActions.acceptRequest')}
          />
        </div>
      ) : offer.statusId == 4 ? (
        <div className="grid md:grid-cols-1 lg:grid-cols-1 2xl:grid-cols-1 xl:grid-cols-1 sm:grid-cols-1 w-[50%] mr-auto ml-auto gap-x-2 mt-5 mb-[-30px]">
          <ButtonIcon
            className="bg-[#DEF3FF] border border-[#DEF3FF] max600:mb-3 sm:mb-3 xl:mb-0 lg:mb-0 2xl:mb-0 md:mb-0 shadow-lg text-[#00CEBC]"
            titleClass={'text-[#00CEBC] text-[14px] font-500'}
            icon={checkOffer}
            dark={false}
            title={t('statusActions.completeRequest')}
          />
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 sm:grid-cols-1 w-[90%] mr-auto ml-auto gap-x-2 mt-5 mb-[-30px]">
          <Button
            loading={loadingUpdateAccept}
            className="bg-[#00CEBC] border border-[#00CEBC] max600:mb-3 sm:mb-3 xl:mb-0 lg:mb-0 2xl:mb-0 md:mb-0 shadow-lg"
            dark={false}
            title={t('listOffers.accept')}
            onClick={() => offerUpdateStatus('accept')}
          />
          <Button
            loading={loadingUpdateReject}
            className="bg-[#FF0000] border border-[#FF0000] max600:mb-3 sm:mb-3 xl:mb-0 lg:mb-0 2xl:mb-0 md:mb-0 shadow-lg"
            dark={false}
            title={t('listOffers.reject')}
            onClick={() => setRejectOfferModal(true)}
          />
        </div>
      )}

      <MConfirmation
        loading={loadingUpdateReject}
        openModal={rejectOfferModal}
        showFooter={true}
        setOpenModal={setRejectOfferModal}
        title={t('listOffers.questionRejectOffer')}
        content={
          <div>

            <div>
              <Textarea
                rows={4}
                onChange={handleRejectMessageChange}
                value={rejectMessage}
                placeholder={t('listOffers.writeCauseReject')}
                label={t('listOffers.causeReject')}
              />
            </div>
          </div>
        }
        singleButton={false}
        confirm={() => offerUpdateStatus('reject')}
      />
    </div>
  );
};

export default CardOffer;
